import Component from '../../../../../../../../lib/component';
import template from './calendar.remind.list.html';
import './calendar.remind.list.scss';
import CalendarRemindItem from './calendar.remind.item/calendar.remind.item'
let config = {
    template: template,
    data: {
    },
    actions: {

    },
    beforeRender(){
    },
    afterRender() {
        let _this = this;
        if(_this.data.remindList){
            if (_this.data.remindList.data != 0) {
                for(let val in _this.data.remindList.data){
                    let fileName = '';
                    if(_this.data.remindList.data[val]['data3show'][0] && _this.data.remindList.data[val]['data3show'][0][0]) {
                        for(let i of _this.data.remindList.data[val]['data3show'][0]) {
                            if(i['fieldId'] === _this.data.remindList.data[val]['selectedRepresents']) {
                                console.log('in', i['fieldValue'])
                                if($.type(i['fieldValue']) == 'object' && i['fieldValue']['-1']){
                                    fileName =i['fieldName'] + ':' + i['fieldValue'][-1];
                                    // fileName =i['fieldValue'][-1];
                                }else{
                                    fileName = i['fieldName'] + ':' + i['fieldValue'];
                                    // fileName = i['fieldValue'];
                                }
                            }
                        }
                        console.log('fileName', fileName)
                        let time = _this.data.remindList.data[val].time;
                        _this.append(new CalendarRemindItem({data:{time:time,fileName:fileName,fontSize:_this.data.fontSize,fileItem:_this.data.remindList.data[val]}}), _this.el.find('.calendar-remind-comment'));
                    }
                }
            }else {
                let html =`<div class='noData'>暂无数据</div>`
                _this.el.find('.calendar-remind-comment').html(html);
            }
            
        }
    },
    firstAfterRender() {}
};
let CalendarRemind = Component.extend(config);

export default CalendarRemind;


// WEBPACK FOOTER //
// app/components/bisystem/canvas/main/cells/cell/calendar/calendar.remind.list/calendar.remind.list.js